<template>
  <el-dialog title="客户申请试用" :visible.sync="dialogFormVisible">

        <el-form :model="form" status-icon :rules="rules" ref="form">
          <el-form-item label="姓名：" prop="username">
            <el-input :disabled="true" v-model="form.username" placeholder="请输入您的用户名" ref="username" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="手机：" prop="phone">
            <el-input :disabled="true" v-model="form.phone" placeholder="请输入您的手机号码" ref="phone" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="邮箱：" prop="email">
            <el-input v-model="form.email" placeholder="请输入您的邮箱账号" ref="email" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="公司：" prop="company">
            <el-input v-model="form.company" placeholder="请输入您的公司名称" ref="company" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="职位：" prop="job">
            <el-input v-model="form.job" placeholder="请输入您的职位" ref="job" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div class="try-product">产品试用：</div>
        <el-tree
          :data="data"
          show-checkbox
          ref="menu"
          node-key="id"
          :default-expanded-keys="[this.ids]"
          :default-checked-keys="[this.ids]"
          :props="defaultProps"
          @check-change="handleCheckChange">
        </el-tree>

        <div class="try">
          <el-button type="primary" :disabled="btnState===false" :class="{btnBg:btnState}" @click="toApply">客户申请试用</el-button>
        </div>


    <div slot="footer" class="dialog-footer">

    </div>
  </el-dialog>
</template>

<script>
import { Category } from "@/api/news";
import { Apply } from "@/api/user";
export default {
  name: "Vip",
  data() {
    // 对用户名进行校验
    const validateName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入用户名'))
      } else {
        callback()
      }
    };
    // 对手机号进行校验
    const validatePassword = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error(('请输入手机号')))
      } else {
        callback()
      }
    };
    return {
      data: [],
      ids: '',
      defaultProps: {
        children: 'children',
        label: 'label',
        id: 'id'
      },
      dialogFormVisible: false,
      form: {
        username: window.localStorage.getItem('username'),
        phone: window.localStorage.getItem('phone'),
        email: '',
        company: '',
        job: '',
      },
      rules: {
        username: [
          //trigger: 'blur'：当失去焦点时（光标不显示的时候），触发此提示
          { validator: validateName, message: '请输入用户名', trigger: 'blur'}
        ],
        phone: [
          { validator: validatePassword, message: '请输入手机号', trigger: 'blur'}
        ]
      },
    }
  },
  created() {
    this.getMenu()
  },
  mounted() {
    let cate = this.$route.query.cate
    switch(cate){
      case 'trend' :
        this.ids = 136
        break;
      case 'review' :
        this.ids = 137
        break;
      case 'market' :
        this.ids = 138
        break;
      case 'chance' :
        this.ids = 139
        break;
      case 'risk' :
        this.ids = 140
        break;
      case 'stocks' :
        this.ids = 141
        break;
      case 'invest' :
        this.ids = 142
        break;
      case 'feature' :
        this.ids = 143
        break;
      default :
        this.ids = 135
    }
  },
  computed :{
    btnState(){//当用户名和密码框都不为空时btnState==true,利用这个计算属性来动态控制按钮的禁用和颜色
      return this.form.username !== "" && this.form.phone !=="" && this.ids !== ""
    },
  },
  methods: {
    init(data){
      this.dialogFormVisible=true;
      //data是父组件弹窗传递过来的值，我们可以打印看看
      // console.log(data);
    },
    getMenu(){
      Category({}).then((response) => {
          // console.log(response);
            this.data = response.data
            // console.log(this.data);

        });
    },
    toApply() {
      let data = {
        customer_name: this.form.username,
        phone_number: this.form.phone,
        mailbox: this.form.email,
        company: this.form.company,
        position: this.form.job,
        try_product: this.ids,
      };
      Apply( data ).then(( response ) => {
        // console.log( response );
        if(response.code === 2000){
           this.$message.success({message:'您的试用申请已成功发送，请等待客服人员处理！',duration:1000,offset:400})
           this.$router.go(0)
        }
      });
    },
    handleCheckChange(data, checked, indeterminate) {
      //获取所有选中的节点 start
      let res = this.$refs.menu.getCheckedNodes()
      let arrId = []
      res.forEach((item) => {
        arrId .push(item.id)
      })
      let s = arrId.toString()
      // console.log(s)
      this.ids = s
      //获取所有选中的节点 end
    }
  }
}
</script>

<style scoped>
>>>.el-dialog__header{
  text-align: center;
}
>>>.btnBg {
  background-color: rgb(0, 22, 70)!important;
  border-color: rgb(0, 22, 70)!important;
}

>>>.el-form-item__content{
  display: flex;
}

.try-product{
  margin-bottom: 10px;
}

.try{
  text-align: center;
  margin-top: 20px;
}

>>>.try .el-button{
  width: 100%;
}

>>>.try .el-button--primary {
  background-color: #87b5f9;
  border-color: #87b5f9;
}
</style>



// WEBPACK FOOTER //
// src/components/common/vip.vue